/* istanbul ignore file */
import React from 'react';
import { useAsyncValue } from 'framework/utils';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { AuthorizationAuthProvider } from 'framework/authorization';

const AuthorizationAuthProviderWrapper = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated } = useAuthenticationService();
  const isUserAuthenticated = useAsyncValue(isAuthenticated);
  return (
    <AuthorizationAuthProvider isAuthenticated={isUserAuthenticated ?? false} backLinkLabel="One Stop">
      {children}
    </AuthorizationAuthProvider>
  );
};

export default AuthorizationAuthProviderWrapper;
